import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'
import { getDefaultTransition } from '../../utils/getDefaultTransition'

interface DropzoneWrapperProps {
  active?: boolean
  blocked?: boolean
  clickDisabled?: boolean
  disabled?: boolean
  raw?: boolean
}

export const DropzoneWrapper = styled.div<DropzoneWrapperProps>`
  ${({ blocked }) =>
    !blocked &&
    css`
      cursor: pointer;
    `}

  ${({ raw, active, clickDisabled }) =>
    !raw &&
    css`
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: ${Spacing.S16};
      border: 2px dashed ${Color.Grey200};
      border-radius: ${BorderRadius.R16};
      position: relative;
      z-index: 0;
      overflow: hidden;
      ${getDefaultTransition('border', 'background')};

      ${!clickDisabled &&
      css`
        &:hover {
          border-color: ${Color.Grey300};
          background-color: ${Color.Grey50};
        }
      `}

      ${active &&
      css`
        border-color: ${Color.Grey300};
        background-color: ${Color.Grey50};
      `}
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      border-color: ${Color.Grey200};
      cursor: not-allowed;
    `}
`
